import React, { useState, useEffect } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import LatestPosts from "../components/LatestPosts";
import { buildApiUrl } from "../utils/urlHelpers";
import SeoMetaTags from "../components/SeoMetaTags";

function PostsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const apiUrl = buildApiUrl('wp/v2/posts?_embed&per_page=12');
    
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setPosts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
        setLoading(false);
      });
  }, []);

  return (
    <Box>
      <SeoMetaTags
        title="Legal Blog - Latest Posts & Articles | Sentry Law"
        description="Read our latest legal blog posts and articles. Stay informed about legal matters, updates, and insights from experienced lawyers at Sentry Law."
        slug="posts"
      />
      <Typography variant="h4" component="h1" gutterBottom>
        All Posts
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <LatestPosts posts={posts} />
      )}
    </Box>
  );
}

export default PostsPage;
